import { clamp } from "@videojs/utils/number";
import { formatTime } from "@videojs/utils/time";
//#region src/core/ui/seek-indicator/status.ts
/** @internal */
function isSeekIndicatorAction(action) {
	return action === "seekStep" || action === "seekToPercent";
}
/** @internal */
function formatCurrentTime(snapshot, locale) {
	const options = locale === void 0 ? void 0 : { locale };
	return formatTime(snapshot.currentTime ?? 0, snapshot.duration, options);
}
/** @internal */
function getSeekIndicatorDisplayValue(state) {
	return state.value ?? state.currentTime;
}
/** @internal */
function getSeekToPercent(event) {
	if (event.value !== void 0) return clamp(event.value, 0, 100);
	if (!event.key || event.key < "0" || event.key > "9") return null;
	return Number(event.key) * 10;
}
/** @internal */
function getSeekDirection(event, snapshot) {
	if (event.action === "seekStep" && event.value !== void 0) {
		if (event.value > 0) return "forward";
		if (event.value < 0) return "backward";
	}
	if (event.action === "seekToPercent") {
		const percent = getSeekToPercent(event);
		if (percent === null || snapshot.duration === void 0 || snapshot.duration <= 0) return null;
		const targetTime = percent / 100 * snapshot.duration;
		const currentTime = snapshot.currentTime ?? 0;
		if (targetTime > currentTime) return "forward";
		if (targetTime < currentTime) return "backward";
	}
	return null;
}
//#endregion
export { formatCurrentTime, getSeekDirection, getSeekIndicatorDisplayValue, getSeekToPercent, isSeekIndicatorAction };

//# sourceMappingURL=status.js.map